import { Box, Button, Theme } from "@mui/material";
import React from "react";
import { createStyles, WithStyles, withStyles } from "@mui/styles";
import { externalEffectReference } from "./types";

const styles = (theme: Theme) =>
    createStyles({
        root: {
            width: "100%",
            padding: theme.spacing(2),
        },
        padContainer: {
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: theme.spacing(2),
            width: "100%",
        },
        button: {
            minHeight: 130,
            fontWeight: 600,
            fontSize: "1.6rem",
        },
        visuallyHidden: {
            border: 0,
            clip: "rect(0 0 0 0)",
            height: 1,
            margin: -1,
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            width: 1,
        },
    });

interface Props extends WithStyles<typeof styles> {
    beats?: externalEffectReference[];
    onBeatSelect: (beat: number) => void;
}

class BeatPad extends React.Component<Props> {
    handleBeat = (beat: number) => {
        this.props.onBeatSelect(beat);
    };

    render() {
        const { beats, classes } = this.props;
        const padButtons = Array.from({ length: 6 }, (_, idx) => ({
            beat: beats?.[idx],
            label: (idx + 1).toString(),
        }));

        return (
            <Box className={classes.root}>
                <Box className={classes.padContainer}>
                    {padButtons.map(({ beat, label }, idx) => {
                        const beatValue = beat?.index ?? idx + 1;
                        const beatName = beat?.name ?? `Beat ${label}`;
                        return (
                            <Button
                                key={beat ? `${beat.index}-${beat.name}` : `placeholder-${idx}`}
                                className={classes.button}
                                variant="contained"
                                color="primary"
                                aria-label={beatName}
                                onClick={() => this.handleBeat(beatValue)}
                                size="large"
                            >
                                {label}
                                {beat?.name ? (
                                    <span className={classes.visuallyHidden}>{beat.name}</span>
                                ) : null}
                            </Button>
                        );
                    })}
                </Box>
            </Box>
        );
    }
}

export default withStyles(styles, { withTheme: true })(BeatPad);
